import React, { useEffect, useState } from "react";
import { useCurrency } from "../context/CurrencyContext";
import { formatMoney } from "../lib/api";

export default function PriceDisplay({ amount, listingCurrency = "RWF", className = "" }) {
  const { selectedCurrency, currencies, getRate } = useCurrency();
  const [converted, setConverted] = useState(null);

  useEffect(() => {
    let active = true;
    if (selectedCurrency === listingCurrency) {
      setConverted(amount);
      return;
    }
    getRate(listingCurrency, selectedCurrency).then((rate) => {
      if (active) setConverted(amount * rate);
    });
    return () => { active = false; };
  }, [amount, listingCurrency, selectedCurrency, getRate]);

  const displayAmount = converted !== null ? converted : amount;
  const displayCurrency = converted !== null ? selectedCurrency : listingCurrency;

  return <span className={className}>{formatMoney(displayAmount, displayCurrency, currencies)}</span>;
}
